import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchAddUser = async (body) => {
  const method = "POST";

  const storedData = localStorage.getItem("logindata");
  let token = "";
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      token = parsedData.data?.token || "";
    } catch (error) {
      console.error("Error parseando el token:", error);
    }
  }

  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  const response = await ApiRequestInterceptor(USERS.adduser, method, body, authHeader);

  if (response.code === 200 || response.code === 201) {
    return response.data;
  } else if (response.code === 401) {
    throw new Error('Credenciales incorrectas');
  } else {
    const errorMessage =
      (response.data && response.data.error) || "Error al agregar usuario";
    throw new Error(errorMessage);
  }
};
